import styles from './SelectiveEndChimeModal.module.css';

/** Modal "Ho ricevuto" per il chime di fine selettiva (PWA puro).
 *  Mostra il primo elemento della coda pendingEndChimes + counter se > 1.
 *  Stili in SelectiveEndChimeModal.module.css. */

export function SelectiveEndChimeModal({
  count, onAck,
}: {
  count: number;
  onAck: () => void;
}): React.JSX.Element {
  return (
    <div className={styles.overlay}>
      <div className={styles.card}>
        <div className={styles.emoji}>✅</div>
        <h2 className={styles.title}>Selettiva terminata</h2>
        <p className={styles.message}>
          L'intervento è stato chiuso. Grazie per la disponibilità.<br />
          <strong>Conferma di aver ricevuto la notifica per fermare il suono.</strong>
        </p>
        {count > 1 && (
          <p className={styles.queueHint}>
            Altre {count - 1} in attesa di conferma
          </p>
        )}
        <button onClick={onAck} className={styles.btn}>
          ✓ Ho ricevuto la notifica
        </button>
      </div>
    </div>
  );
}
